export const OPENCLOSE_SIDEMENU = "OPENCLOSE_SIDEMENU";
export const OPEN_FORMMENU = "OPEN_FORMMENU";
export const OPEN_USUARIOS = "OPEN_USUARIOS";

export const UPLOADING_IMAGE = "UPLOADING_IMAGE";

export const LOAD_ACTIVITIES = "LOAD_ACTIVITIES";
export const OPEN_ACTIVITIES = "OPEN_ACTIVITIES";

export const LOAD_USERS = "LOAD_USERS";

export const OPEN_INFORMATIONS = "OPEN_INFORMATIONS";
export const LOAD_INFORMATIONS = "LOAD_INFORMATIONS";

export const LOAD_FAVOURITES = "LOAD_FAVOURITES";
export const OPEN_FAVOURITES = "OPEN_FAVOURITES";

export const LOAD_PROMOTIONS = "LOAD_PROMOTIONS";

export const OPEN_PROMOTIONS = "OPEN_PROMOTIONS";

export const LOAD_PRINCIPAL = "LOAD_PRINCIPAL";

export const OPEN_PRINCIPAL = "OPEN_PRINCIPAL";

export const OPEN_PHOTOS = "OPEN_PHOTOS";
export const LOAD_PHOTOS = "LOAD_PHOTOS";
export const INSERT_EVENT = "INSERT_EVENT";

export const OPEN_INVERSIONES = "OPEN_INVERSIONES";
export const LOAD_INVERSIONES = "LOAD_INVERSIONES";

export const OPEN_RESTAURANTS = "OPEN_RESTAURANTS";
export const LOAD_RESTAURANTS = "LOAD_RESTAURANTS";

export const OPEN_OTHERTEXTS = "OPEN_OTHERTEXTS";
export const LOAD_OTHERTEXTS = "LOAD_OTHERTEXTS";
